import promise from './promise';
import config from '../../../config/api.config';

var defaultApiList = [
    'launch3rdApp',
    'getInstallState',
    'checkJsApi'
];
function _loadScript (src, callback) {
    var script = document.createElement('script');
    script.async = "async";
    script.src = src;
    if (callback) {
        script.onload = callback;
    }
    document.getElementsByTagName("head")[0].appendChild(script);
}

function WX (opts) {
  opts = opts || {};
  opts.apiList = opts.apiList||defaultApiList;
  _loadScript('//res.wx.qq.com/open/js/jweixin-1.1.0.js',function(){
    promise.ajax('POST', config.api + 'weixin/getjsconfig/1.0', {
      url: location.href.split('#')[0],
      mpid: 'gh_c6feb778444d'
    }).then(function (err, res) {
      if(!err) {
        res = JSON.parse(res);
        if (res.status.code == 0) {
          var args = res.result;
          wx.config({
            beta: true, // 必填，开启内测接口调用，注入wx.invoke和wx.on方法
            debug: false,
            appId: args.appId,
            timestamp: args.timestamp,
            nonceStr: args.nonceStr,
            signature: args.signature,
            jsApiList: opts.apiList
          });
          wx.ready(opts.cb);
        }
      }
    });
  });
}

export default WX;


/** WEBPACK FOOTER **
 ** ./common/js/wxconfig.js
 **/